import routerOptions0 from "/usr/src/app/content/n3-spas-60b21071-528e-464e-be89-0fedee80c583/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}